/** @format — Documents grid cards */

import DocumentGridCard from "./DocumentGridCard";
import type { DocumentItem } from "../types";

export default function DocumentsGrid({
  documents,
  onOpen,
  onGoToShipment,
}: {
  documents: DocumentItem[];
  onOpen: (doc: DocumentItem) => void;
  onGoToShipment: (doc: DocumentItem) => void;
}) {
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 sm:gap-4 md:grid-cols-4 lg:grid-cols-5 xl:grid-cols-7">
      {documents.map((document) => (
        <DocumentGridCard
          key={document.id}
          document={document}
          onOpen={onOpen}
          onGoToShipment={onGoToShipment}
        />
      ))}
    </div>
  );
}
